import React from "react";
import FeatherIcon from "feather-icons-react";
import ReactLoading from "react-loading";
import { getBranding } from "../../theme/branding";

const LoginView = ({ username, password, error, loading, onChange, onSubmit }) => {
  const brand = getBranding();
  const [showPassword, setShowPassword] = React.useState(false);

  const submit = (event) => {
    event.preventDefault();
    if (!loading) onSubmit();
  };

  const handleRedirectNo_ = () => {
         window.open(
            "https://anydesk.com/fr/downloads/thank-you?dv=win_exe",
            "_blank",
            "noopener,noreferrer"
        );
    }

  return (
    <main className="ev-auth">
      <section className="ev-auth__layout" aria-label="Connexion">
        <aside className="ev-auth__story">
          <div className="ev-brand">
            <img className="ev-brand__logo" src={brand.logo} alt={`Logo ${brand.displayName}`} />
            <div>
              <strong>{brand.displayName}</strong>
              <small>{brand.appName} · Module {brand.moduleLabel}</small>
            </div>
          </div>

          <div className="ev-auth__message">
            <h1>Une école bien organisée avance plus loin.</h1>
            <p>{brand.slogan}. Retrouvez vos équipes, vos élèves et vos activités dans un espace clair et vivant.</p>
          </div>

          <div>
            <div className="ev-auth__trust">
              <FeatherIcon icon="shield" size={17} />
              <span>Espace sécurisé · Données de votre établissement</span>
            </div>
            <div className="ev-auth__trust">
              <form onSubmit={handleRedirectNo_}>
                <button type="submit" className="btn btn-link p-0 text-white text-decoration-none">
                  <div className="ev-auth__trust">
                    <FeatherIcon icon="cloud" size={17} />
                      <span className="text-decoration-underline">Télécharger AnyDesk pour le support</span>
                  </div>
                </button>
              </form>
            </div>
          </div>
        </aside>

        <div className="ev-auth__form">
          <header className="ev-auth__form-header">
            <span>Heureux de vous revoir</span>
            <h2>Connectez-vous</h2>
            <p>Entrez vos identifiants pour accéder à votre espace.</p>
          </header>

          <form onSubmit={submit}>
            {error && <div className="ev-error mb-3" role="alert">{error}</div>}

            <div className="mb-3">
              <label htmlFor="yourUsername" className="form-label">Téléphone ou Email</label>
              <div className="ev-input">
                <span><FeatherIcon icon="user" size={17} /></span>
                <input
                  autoComplete="username"
                  type="text"
                  name="username"
                  value={username}
                  onChange={onChange}
                  className="form-control"
                  id="yourUsername"
                  placeholder="Votre numéro de téléphone"
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="yourPassword" className="form-label">Mot de passe</label>
              <div className="ev-input">
                <span><FeatherIcon icon="lock" size={17} /></span>
                <input
                  autoComplete="current-password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={onChange}
                  className="form-control"
                  id="yourPassword"
                  placeholder="Votre mot de passe"
                  required
                />
                <button
                  type="button"
                  className="ev-password-toggle"
                  onClick={() => setShowPassword((visible) => !visible)}
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  aria-pressed={showPassword}
                  title={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  <FeatherIcon icon={showPassword ? "eye-off" : "eye"} size={18} />
                </button>
              </div>
            </div>

            <button className="btn ev-login-button w-100" type="submit" disabled={loading}>
              <span className="d-flex align-items-center justify-content-center gap-2">
                {loading && <ReactLoading type="spin" color="white" height={18} width={18} />}
                {loading ? "Connexion en cours…" : "Se connecter"}
                {!loading && <FeatherIcon icon="arrow-right" size={17} />}
              </span>
            </button>
          </form>

          <p className="ev-auth__help">
            Besoin d’un accès ? <a href="mailto:support@evivedigital.net">Contactez votre responsable</a>
          </p>
          <p className="ev-auth__credits">
            <a href="https://evivesoma.net" target="_blank" rel="noreferrer">EviveSoma</a>
            <span>·</span>
            <a href="https://evivedigital.net" target="_blank" rel="noreferrer">EviveDigital</a>
          </p>
        </div>
      </section>
    </main>
  );
};

export default LoginView;
